import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IGenericCodebookItem } from "../model/GenericCodebookItem";
import GenericCodebookItemMapper from "../model/GenericCodebookItemMapper";
import GenericCodebookItemParamMapper from "../model/GenericCodebookItemParamMapper";

export default class GetGenericCodebookInteractor {
  private resource: GetAllResourceEntriesInteractor<IGenericCodebookItem>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(codebookType: string, includeDeleted: boolean) {
    return this.resource.execute(
      `codebooks/generic/types/${codebookType}`,
      GenericCodebookItemMapper,
      GenericCodebookItemParamMapper,
      {
        params: { includeDeleted }
      }
    );
  }
}
